import axios from 'axios';
import { API_ENDPOINT } from "src/constants/endpoints";

export const axBackendInstance = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
  },
});